import { injectable } from "inversify";
import { ColumnOrderState, VisibilityState } from "@tanstack/react-table";

export interface IUserSettingsService {
  setColumnOrder(columnOrder: string[], settingName: string): void;
  getColumnOrder(settingName: string): Promise<ColumnOrderState>;
  setVisibleColumns(visibleColumns: VisibilityState, settingName: string): void;
  getVisibleColumns(settingName: string): Promise<VisibilityState>;
}

@injectable()
export class UserSettingsService {
  readonly storage: Storage = localStorage;

  async setColumnOrder(columnOrderState: ColumnOrderState, settingName: string) {
    const flatColumnOrder = JSON.stringify(columnOrderState);
    this.storage.setItem(settingName, flatColumnOrder);
  }

  async getColumnOrder(settingName: string): Promise<ColumnOrderState> {
    const flatColumnOrder = this.storage.getItem(settingName) ?? '[""]';
    const columnOrder = JSON.parse(flatColumnOrder);
    return columnOrder;
  }

  async setVisibleColumns(visibleColumns: VisibilityState, settingName: string) {
    const flatVisibleColumns = JSON.stringify(visibleColumns);
    if (flatVisibleColumns !== "{}") {
      this.storage.setItem(settingName, flatVisibleColumns);
    }
  }

  async getVisibleColumns(settingName: string): Promise<VisibilityState> {
    const flatColumnOrder = this.storage.getItem(settingName) ?? '[""]';
    const columnOrder = JSON.parse(flatColumnOrder);
    return columnOrder;
  }
}
